import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';

const HomeContainer = styled.div`
  width: 100%;
  padding: 0;
`;

const HeroSection = styled.div`
  background: linear-gradient(135deg, ${props => props.theme.colors.primary} 0%, ${props => props.theme.colors.secondary} 100%);
  color: white;
  padding: 80px 20px;
  text-align: center;
  margin-bottom: 60px;

  h1 {
    font-size: 3em;
    margin: 0 0 20px 0;
    font-weight: bold;
  }

  p {
    font-size: 1.2em;
    margin: 0 0 30px 0;
    opacity: 0.95;
    max-width: 600px;
    margin-left: auto;
    margin-right: auto;
  }
`;

const CTAButton = styled.button`
  background-color: white;
  color: ${props => props.theme.colors.primary};
  border: none;
  padding: 14px 32px;
  font-size: 1em;
  font-weight: bold;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.3s ease;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 8px 16px rgba(0, 0, 0, 0.2);
  }

  &:active {
    transform: translateY(0);
  }
`;

const FeaturedSection = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px 60px 20px;

  h2 {
    text-align: center;
    font-size: 2.2em;
    margin-bottom: 50px;
    color: ${props => props.theme.colors.text};
  }
`;

const FeatureGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 30px;
  margin-bottom: 40px;
`;

const FeatureCard = styled.div`
  background-color: ${props => props.theme.colors.surfaceColor || props.theme.colors.tableBgColor || '#2a2a2a'};
  border: 1px solid ${props => props.theme.colors.borderColor};
  border-radius: 12px;
  padding: 40px 30px;
  text-align: center;
  transition: all 0.3s ease;
  cursor: pointer;
  
  &:hover {
    transform: translateY(-8px);
    box-shadow: 0 12px 24px rgba(0, 0, 0, 0.3);
    border-color: ${props => props.theme.colors.primary};
  }

  .icon {
    font-size: 3.5em;
    margin-bottom: 20px;
  }

  h3 {
    font-size: 1.5em;
    margin: 0 0 15px 0;
    color: ${props => props.theme.colors.text};
  }

  p {
    font-size: 0.95em;
    color: ${props => props.theme.colors.secondary};
    margin: 0 0 25px 0;
    line-height: 1.6;
  }

  button {
    width: 100%;
    padding: 12px;
    background-color: ${props => props.theme.colors.buttonBgColor || props.theme.colors.primary};
    color: ${props => props.theme.colors.buttonTextColor || 'white'};
    border: none;
    border-radius: 6px;
    font-size: 1em;
    font-weight: bold;
    cursor: pointer;
    transition: all 0.2s ease;

    &:hover {
      background-color: ${props => props.theme.colors.buttonHoverBg || '#1976D2'};
    }
  }
`;

const Home = () => {
  const navigate = useNavigate();

  return (
    <HomeContainer>
      <HeroSection>
        <h1>Fantasy Football Toolz</h1>
        <p>Track your weekly predictions, compete with friends, and dominate your league</p>
        <CTAButton onClick={() => navigate('/weekly-picks')}>
          Get Started
        </CTAButton>
      </HeroSection>

      <FeaturedSection>
        <h2>Featured Tools</h2>
        <FeatureGrid>
          <FeatureCard onClick={() => navigate('/weekly-picks')}>
            <div className="icon">📊</div>
            <h3>Weekly Picks</h3>
            <p>Enter your predictions for the week and track your picks against the spread</p>
            <button>View Picks</button>
          </FeatureCard>
        </FeatureGrid>
      </FeaturedSection>
    </HomeContainer>
  );
};

export default Home;